export const DEFAULT_TIMESHEETS_SORTING = [{ fieldName: 'employeeName', orderDirection: 'ASC' as const }];
export const DEFAULT_TIMESHEETS_FILTERS = {
  userIds: [],
  projectIds: [],
  accountIds: [],
};

export const DEFAULT_TIMESHEETS_SIZE = 1;
